<template>
  <ls-search-form :formList="formList" @search="onSearch" ref="searchForm">
    <ls-select
      slot="factoryCode"
      v-decorator="['factoryCode']"
      :showSearch="true"
      placeholder="请选择"
      :options="selectSupplierList"
      allowClear
      :filter-option="filterOption"
      @search="handleSupplierSearch"
    />
    <lsSelectPage
      slot="dispatcherNo"
      v-decorator="['dispatcherNo']"
      :datas="dispatcherList"
      searchKey="dispatcher"
      valueKey="jobNo"
      placeholder="请选择"
    >
      <template slot="select-option" slot-scope="{items}">
        <a-select-option v-for="(i, index) in items" :key="index" :value="i.jobNo" :title="i.realName">
          {{ `${i.jobNo}-${i.realName}` }}
        </a-select-option>
      </template>
    </lsSelectPage>
    <template #warehouseCode>
      <global-select
        v-decorator="['warehouseCode']"
        @successCallBack="successCallBack"
        requestApi="/system/lookup/data/list"
        :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
        :setParams="{ lookupType: '4PL_WAREHOUSE_DESCRIPTION', pageSize: 1000 }"
      />
    </template>
  </ls-search-form>

</template>
<script>

// import { COMPLETE_STATUS, STATUS } from '@/views/mes/scheduling-plan/unsatisfactory-receiving/enum'
import { apiGetDispatchList, apiGetsupplier } from '@/services/module/receiving-plan'

export default {
  name: 'UnsatisfactoryDetailSearchForm',
  data() {
    return {
      selectSupplierList: [],
      dispatcherList: []
    }
  },
  computed: {
    formList() {
      return [
        {
          label: "供应商",
          type: "factoryCode",
          decorator: ['factoryCode'],
          attrs: {
            placeholder: '请输入'
          }
        },
        // 初始 - 0; 10 - 已推送；15 - 安排中；20 - 已关闭；
        {
          label: "入库优先级",
          type: "input",
          decorator: ['supplierPriorityLevel'],
          attrs: {
            placeholder: "请输入"
          }
        },
        {
          label: "物料编码",
          type: "input",
          decorator: ['materialNo'],
          attrs: {
            placeholder: "请输入"
          }
        },
        {
          label: "物料名称",
          type: "input",
          decorator: ['materialName'],
          attrs: {
            placeholder: "请输入"
          }
        },
        {
          label: "存放区域",
          type: "input",
          decorator: ['depositAreaName'],
          attrs: {
            placeholder: "请输入"
          }
        },
        {
          label: "要求到货日期",
          type: "date",
          decorator: ['requireDeliveryDayValue'],
          attrs: {
            placeholder: "请输入",
            style: {
              width: '100%'
            }
          }
        },
        {
          label: "供应商仓",
          type: "input",
          decorator: ['factoryWarehouseName'],
          attrs: {
            placeholder: "请输入"
          }
        },
        // {
        //   label: "采购员编码",
        //   type: "input",
        //   decorator: ['purchaseUserNo'],
        //   attrs: {
        //     placeholder: "请输入"
        //   }
        // },
        {
          label: "采购员",
          type: "input",
          decorator: ['purchaseUserName'],
          attrs: {
            placeholder: "请输入"
          }
        },
        {
          label: "是否独占(单工厂）",
          type: "select",
          decorator: ['supplierExclusiveIs'],
          options: [
            {
              value: '是',
              key: 1
            },
            {
              value: '否',
              key: 0
            }
          ],
          attrs: {
            placeholder: "请输入"
          }
        },
        {
          label: "入库仓库",
          type: "warehouseCode",
          decorator: ['warehouseCode'],
          attrs: {
            placeholder: "请输入"
          }
        },
        {
          label: "增减货标识",
          type: "select",
          decorator: ['loadAddIs'],
          options: [
            {
              value: '非增减货',
              key: 0
            },
            {
              value: '增货',
              key: 1
            },
            {
              value: '减货',
              key: 2
            }
          ],
          attrs: {
            placeholder: "请输入"
          }
        },
        {
          label: "调度员",
          type: "dispatcherNo",
          decorator: ['dispatcherNo'],
          attrs: {
            placeholder: "请输入"
          }
        }
      ]
    }
  },
  methods: {
    // 手动输入
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().trim().indexOf(input.toLowerCase().trim()) >= 0
    },
    onSearch (val) {
      const data = val
      data.requireDeliveryDay = val.requireDeliveryDayValue ? val.requireDeliveryDayValue.format('yyyy-MM-DD') : undefined
      data.purchaseUserName = val.purchaseUserName ? val.purchaseUserName?.trim() : undefined
      this.$emit('search', data)
    },
    getFormData() {
      return this.$refs.searchForm.form.getFieldsValue()
    },
    handleSupplierSearch (val) {
      apiGetsupplier({ supplierQueryStr: val, page: 1, pageSize: 50 }).then(res => {
        this.selectSupplierList = res?.data?.map(item => {
          return {
            value: item.companyCode,
            label: item.companyName
          }
        }) || []
      })
    },
    // 获取调度组成员列表
    getDispatchList () {
      return new Promise(resolve => {
        apiGetDispatchList().then(res => {
          if (res.code === 200) {
            this.dispatcherList = res.rows.map(item => {
              return {
                ...item,
                dispatcher: `${item.jobNo}-${item.realName}`
              }
            })
            resolve(this.dispatcherList)
          }
        })
      })
    },
    setFormValue(val) {
      this.$refs.searchForm.form.setFieldsValue(val)
    },
    successCallBack(list) {
      const findName = ['基地仓', '青岛仓库', '佛山仓库']
      findName.forEach(e => {
        const findIndex = list.findIndex(x => x.lookupValue.indexOf(e) > -1)
        if (findIndex > -1) {
          const val = list[findIndex]
          list.splice(findIndex, 1)
          list.unshift(val)
        }
      })
    }
  },
  created() {
    this.handleSupplierSearch()
    this.getDispatchList()
  }
}
</script>
